export const COMISSOES = [
    { label: 'CPL Educação', value: 'CPL Educação' },
    { label: 'CPL G', value: 'CPL G' },
    { label: 'CPL Obras', value: 'CPL Obras' },
    { label: 'CPL P', value: 'CPL P' },
    { label: 'CPL São João', value: 'CPL São João' },
    { label: 'CPL Saúde', value: 'CPL Saúde' },
    { label: 'CPL SDSDH', value: 'CPL SDSDH' },
    { label: 'CPL CEACA', value: 'CPL CEACA' },
    { label: 'UC- G', value: 'UC- G' },
    { label: 'UC-P', value: 'UC-P' },
    { label: 'UC-O', value: 'UC-O' },
    { label: 'UC-SDSDH', value: 'UC-SDSDH' },
    { label: 'UC-SMS', value: 'UC-SMS' },
    { label: 'UC- EDUCAÇÃO', value: 'UC- EDUCAÇÃO' },
    { label: 'NÃO SE APLICA', value: 'NÃO SE APLICA' }
];



// WEBPACK FOOTER //
// ./src/app/_mocks/comissoes.ts